import * as React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  height: 100%;
`;

const ScrollSection: React.SFC<{}> = (props) => {
  return (
    <Wrapper>{props.children}</Wrapper>
  )
}

export default ScrollSection;



// WEBPACK FOOTER //
// ./src/components/ScrollSection/ScrollSection.tsx